import JobStatus from 'infra/JobStatus'
import ClockingType from 'infra/ClockingType'

const ClockUtils = {

  getClockData: (eventInfo, dateStr) => {
    const modules = eventInfo.commonInfo && eventInfo.commonInfo.modules
    const extendedInfo = eventInfo.extendedInfo && eventInfo.extendedInfo.modules
    const clockingType = ClockUtils.getClockingType(modules)
    let jobStatus
    switch (clockingType) {
      case ClockingType.CLOCKING_EXTENDED:
        jobStatus = ClockUtils.getClockExtendedData(clockingType, extendedInfo, dateStr)
        break
      case ClockingType.CLOCKING_LINE_ITEMS:
      case ClockingType.CLOCKING_WORKER:
        jobStatus = ClockUtils.getClockWorkerData(clockingType, modules.workers.list, extendedInfo, dateStr)
        break
    }
    return { type: clockingType, status: jobStatus }
  },

  getClockingType: modules => {
    if (modules && modules.clockingExtended) {
      return ClockingType.CLOCKING_EXTENDED
    }
    else
    if (modules && modules.clockingWorker) {
      return ClockingType.CLOCKING_WORKER
    }
    else
    if (modules && modules.clockingLineItems) {
      return ClockingType.CLOCKING_LINE_ITEMS
    }
  },

  getClockWorkerData: (clockingType, workersList, extendedInfo, dateStr) => {
    const clockingModule = extendedInfo && extendedInfo[clockingType] && extendedInfo[clockingType][dateStr]
    if (clockingModule) {
      let timeIn = false
      let timeOutAll = true
      for (const id in workersList) {
        const info = clockingModule[id]
        if (info && info.timeIn){
          timeIn = true
        }
        if (!info || !info.timeOut) {
          timeOutAll = false
        }
      }
      if (timeIn && timeOutAll) {
        return JobStatus.COMPLETED
      }
      else
      if (timeIn && !timeOutAll) {
        return JobStatus.IN_PROGRESS
      }
      else
      if (!timeIn && !timeOutAll){
        return JobStatus.NOT_STARTED
      }
      else {
        //??? Users should not be able to clock out before clock in
      }
    }
    return JobStatus.NOT_STARTED
  },

  getClockExtendedData: (clockingType, extendedInfo, dateStr) => {
    const clockingExtended = extendedInfo && extendedInfo[clockingType] && extendedInfo[clockingType][dateStr]
    if (clockingExtended) {
      const { timeIn, timeOut } = clockingExtended
      if (timeIn && timeOut) {
        return JobStatus.COMPLETED
      }
      else if (timeIn && !timeOut) {
        return JobStatus.IN_PROGRESS
      }
      else
      if (!timeIn && !timeOut) {
        return JobStatus.NOT_STARTED
      }
      else {
        //??? Users should not be able to clock out before clock in
      }
    }
    return JobStatus.NOT_STARTED
  }

}

export default ClockUtils



// WEBPACK FOOTER //
// ./src/schedule/common/ClockUtils.js